module.exports = __webpack_public_path__ + "static/media/notifAlert.e1dd3fdf.wav";